import * as React from 'react';
import { IRecordedDeed } from '../classes/RecordedDeed';
import { IRecordedMortgage } from '../classes/RecordedMortgage';
import { PolicyTypeEnum } from '../classes/PolicyTypeEnum';
import { FormCell } from 'ui-toolkit';
import { eTransactionCategory } from '../../ui-toolkit/enums/eTransactionType';

interface IAmericanDigitalDetails {
  recordedDeed: IRecordedDeed;
  recordedMortgage: IRecordedMortgage;
  policyType: PolicyTypeEnum;
  transactionType: eTransactionCategory;
}

export const AmericanDigitalPreview: React.FC<IAmericanDigitalDetails> = (props) => (
  <>
    {props.policyType === PolicyTypeEnum.owner ? (
      <>
        <FormCell label={'Grantee(s)'} wrapInput={false}>
          {props.recordedDeed.grantee || 'None'}
        </FormCell>
        <FormCell label={'Grantor(s)'} wrapInput={false}>
          {props.recordedDeed.grantor || 'None'}
        </FormCell>
      </>
    ) : props.transactionType === eTransactionCategory.Purchase ? (
      <>
        <FormCell label={'Grantee/Mortgagor'} wrapInput={false}>
          {props.recordedDeed.grantee || 'None'}
        </FormCell>
        <FormCell label={'Grantor(s)'} wrapInput={false}>
          {props.recordedDeed.grantor || 'None'}
        </FormCell>
      </>
    ) : (
      <>
        <FormCell label={'Mortgagor'} wrapInput={false}>
          {props.recordedMortgage.mortgagor_name || 'None'}
        </FormCell>
      </>
    )}
  </>
);
